var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-pull-refresh',{staticStyle:{"height":"100vh"},on:{"refresh":_vm.onRefresh},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}},[_c('p',[_vm._v("刷新次数: "+_vm._s(_vm.count))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }